import axios from "../instance";

export default {
  getAll: () => {
    return axios.api.get("/productTypes").then((response) => response.data);
  },
  getOne: (id) => {
    return axios.api
      .get(`/productTypes/${id}`)
      .then((response) => response.data);
  },
  search: (body) => {
    return axios.api
      .post("/productTypes/search", body)
      .then((response) => response.data);
  },
  create: (body) => {
    return axios.api
      .post("/productTypes", body)
      .then((response) => response.data);
  },
  update: (id, body) => {
    return axios.api
      .put(`/productTypes/${id}`, body)
      .then((response) => response.data);
  },
  delete: (id) => {
    return axios.api
      .delete(`/productTypes/${id}`)
      .then((response) => response.data);
  },
};
